export const BenchmarkTypeOf = "BENCHMARK"

export const BenchmarkCategories = ["HUSTLE_UP", "GIRLS", "OPEN", "GAMES", "HEROES"] as const
export type BenchmarkCategory = (typeof BenchmarkCategories)[number]
